import React, { Component } from 'react';
import {notification, Modal } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

export const showSuccess = (title, description, icon, color) => {
  notification.open({
    message: title ? title : 'Succesvol opgeslagen',
    icon: icon ? icon : <CheckCircleFilled style={{ color: color ? color : '#52c41a' }} />,
    description: description ? description : '',
    placement: 'topRight',
  });
}

export const showError = (title, description, icon, color) => {
  notification.open({
    message: title ? title : 'Error',
		icon: icon ? icon : <CheckCircleFilled style={{ color: color ? color : '#ff0000' }} />,
    description: description ? description : '',
    placement: 'topRight',
  });
}

export const showMultiDelete = (callback) => {
  Modal.confirm({
    title: 'Wil je deze items verwijderen?',
    content: 'Als je op JA klikt, worden de items verwijderd.',
    okText: 'Ja',
    okType: 'danger',
    cancelText: 'Nee',
    onOk: () => {
      callback(true);
    },
    onCancel() {
      callback(false);
    },
  });
}

export const showExtraConfirm = (callback, title, description) => {
  Modal.confirm({
    title: title ? title : 'Weet je het zeker?',
    content: description ? description : 'Als je op JA klikt, wordt uw actie uitgevoerd.',
    okText: 'Ja',
    okType: 'danger',
    cancelText: 'Nee',
    onOk: () => {
      callback(true);
    },
    onCancel() {
      callback(false);
    },
  });
}
